import { CSSObject } from "@emotion/react";
import {
  constants,
  typographyStyles,
  type AngelouCSS,
  type FilterChipStyleOverrides,
  type TextAreaStyleOverrides,
} from "@newsela/angelou";
import { gradientBackgrounds } from "@/components/AIComponents/AiComponents.style";

export const lunaFilterPanelContainerCss: CSSObject = {
  maxHeight: "566px",
  background: constants.colors.ui.white[500],
  overflow: "auto",
  padding: "16px",
  borderBottomRightRadius: "24px",
};

export const lunaContentContainerCss: CSSObject = {
  background: gradientBackgrounds[100],
  padding: "16px",
  borderRadius: "8px",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "inherit",
    padding: "1px",
    background: gradientBackgrounds[500],
    WebkitMask:
      "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
    pointerEvents: "none",
    zIndex: 0,
  },
};

export const lunaTagsContainerCss: CSSObject = {
  display: "flex",
  gap: "8px",
  marginBottom: "8px",
};

export const toggleWrapperCss: CSSObject = {
  marginBottom: "16px",
};

export const lunaResultsHeaderCss: CSSObject = {
  ...typographyStyles.heading5Obj,
  fontWeight: 700,
  margin: "4px 0 8px 0",
  color: constants.colors.ui.neutral[700],
};

export const lunaQueryTextCss: CSSObject = {
  margin: "0",
  color: constants.colors.ui.neutral[700],
};

export const lunaFiltersHeaderCss: CSSObject = {
  ...typographyStyles.heading5Obj,
  fontWeight: 700,
  margin: "16px 0 4px 0",
  color: constants.colors.ui.neutral[700],
};

export const lunaChipGroupCss: FilterChipStyleOverrides<AngelouCSS> = {
  root: {
    display: "flex",
    flexWrap: "wrap",
    "> div": {
      marginLeft: "3px",
    },
  },
};

export const labelQuestionCss = {
  ...typographyStyles.textM,
  fontSize: "1rem",
  lineHeight: "1.5rem",
  color: constants.colors.ui.neutral[700],
  fontWeight: 400,
  whiteSpace: "pre-wrap",
};

export const lunaChipWrapperCss: CSSObject = {
  marginLeft: "3px",
  li: {
    "> div": {
      maxHeight: "24px",
    },
  },
};

export const lunaQuestionHeaderCss: CSSObject = {
  ...typographyStyles.heading5Obj,
  fontWeight: 700,
  margin: "16px 0 4px 0",
  color: constants.colors.ui.neutral[700],
};

export const lunaQuestionContainerCss: CSSObject = {
  position: "relative",
};

export const lunaPeekingIconWrapperCss: CSSObject = {
  position: "absolute",
  right: "-24px",
  top: "-8px",
};

export const lunaRefineButtonCss: CSSObject = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  maxHeight: "32px",
};

export const lunaTextAreaCss: TextAreaStyleOverrides<AngelouCSS> = {
  root: {
    textarea: {
      height: "46px",
      overflow: "auto",
    },
    label: labelQuestionCss,
  },
};
